import { render, staticRenderFns } from "./TextFieldEditBudgetDashboard.vue?vue&type=template&id=6cb31e6f&"
import script from "./TextFieldEditBudgetDashboard.vue?vue&type=script&lang=js&"
export * from "./TextFieldEditBudgetDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports